//
//
//
//
//
//
//
//
//
//
//
//

import Dropdown from './Dropdown.vue'
export default {
  name: "BlueQuery",
  props: ["executeSearch", "extend", "extended", "clearPreviousItemResults"],
  components: {Dropdown},
  data() {
    return {
    };
  },
  computed: {
    activeDropdowns() {
      return this.extended.dropdowns.filter(d => d.active);
    },
  }
};
